import AnnouncmentItem from './AnnouncmentItem';

export default AnnouncmentItem;
